import React, { useRef, useState, useImperativeHandle, forwardRef } from 'react';
import Cropper from 'react-cropper';
import { useTranslation } from 'react-i18next';
import { getTranslation } from '../../utils';

const ImageCropPopup = forwardRef(({ imageUrl, onImageSet, turnOffCropper, orgPrefix }, ref) => {
  const { t } = useTranslation();
  const imageRef = useRef(null);
  const [cropper, setCropper] = useState();

  const getCropData = async () => {
    if (typeof cropper !== 'undefined') {
      const blobImage = await dataToBlob(cropper.getCroppedCanvas().toDataURL());
      onImageSet(blobImage);
      turnOffCropper();
    }
  };

  const getCropDataAsBlob = async () => {
    if (typeof cropper !== 'undefined') {
      const blobImage = await dataToBlob(cropper.getCroppedCanvas().toDataURL());
      return blobImage;
    }
    return null;
  };

  // Expose methods to parent component
  useImperativeHandle(ref, () => ({
    getCropData,
    getCropDataAsBlob
  }));

  return (
    <section className="">
      {/* <div className="text-center mt-6">
        <div className="heading">{t(`imageProfile.imgCrop.title`)}</div>
        <div>{t(`imageProfile.imgCrop.subtitle`)}</div>
      </div> */}
      <Cropper
        style={{ height: 400, width: '100%', marginTop: '20px' }}
        initialAspectRatio={1}
        preview=".img-preview"
        src={imageUrl}
        ref={imageRef}
        viewMode={1}
        guides={true}
        minCropBoxHeight={100}
        minCropBoxWidth={100}
        background={false}
        zoomable={false}
        responsive={true}
        checkOrientation={false}
        aspectRatio={1}
        onInitialized={(instance) => {
          setCropper(instance);
        }}
      />
    </section>
  );
});

ImageCropPopup.displayName = 'ImageCropPopup';

export default ImageCropPopup;

const dataToBlob = async (imageData) => {
  return await (await fetch(imageData)).blob();
};
